export default __webpack_public_path__ + "static/media/introduction.2f66e2c9.mp4";